import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onBeforeUnmount } from 'vue';
  import Button from '@/components/common/Button.vue';
  import { useRouter } from '@/router';

  
  import { defineComponent } from 'vue';

  const __default__ = defineComponent({
    name: 'PageNotFound',
  });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  const router = useRouter();

  onMounted(() => {
    window.addEventListener('keydown', handleKeyDown);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyDown);
  });

  function handleKeyDown(event: KeyboardEvent) {
    event.preventDefault();

    if (event.code === 'Enter') {
      navigateToHome();
    }
  }

  function navigateToHome() {
    router.push('/');
  }

return { __sfc: true,router, handleKeyDown, navigateToHome, Button }
}

})